var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 15.75V10.2C6.75 9.77992 6.75 9.56992 6.83175 9.4095C6.90365 9.26835 7.01839 9.15367 7.15951 9.08175C7.31995 9 7.53 9 7.95 9H10.05C10.4701 9 10.6801 9 10.8405 9.08175C10.9817 9.15367 11.0963 9.26835 11.1682 9.4095C11.25 9.56992 11.25 9.77992 11.25 10.2V15.75M1.5 7.125L8.28 2.04C8.53822 1.84636 8.6673 1.74953 8.80905 1.7122C8.93423 1.67926 9.06577 1.67926 9.19095 1.71221C9.3327 1.74953 9.46178 1.84636 9.72 2.04L16.5 7.125M3 6V13.35C3 14.1901 3 14.6101 3.16349 14.931C3.3073 15.2132 3.53678 15.4427 3.81902 15.5865C4.13989 15.75 4.55992 15.75 5.4 15.75H12.6C13.4401 15.75 13.8602 15.75 14.181 15.5865C14.4632 15.4427 14.6927 15.2132 14.8365 14.931C15 14.6101 15 14.1901 15 13.35V6L10.44 2.58C9.92363 2.19271 9.6654 1.99906 9.38182 1.92442C9.13155 1.85853 8.86845 1.85853 8.61818 1.92442C8.3346 1.99906 8.07637 2.19271 7.56 2.58L3 6Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRent);
export default __webpack_public_path__ + "static/media/rent.33064aa711c78d299dfc86562fa4ef48.svg";
export { ForwardRef as ReactComponent };